var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vb-quote-view"},[_c('b-container',[(_vm.loading)?_c('section',{staticClass:"section section--loader"},[_c('loader',{attrs:{"size":"large","show_timing_slot":true}})],1):_c('section',{staticClass:"section"},[_c('quote',{attrs:{"quote":_vm.quote}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }